<script lang="ts">
    import IntroductionText from "./columnTypes/IntroductionText.svelte"
    import HomePageSlider from "./widgets/HomePageSlider.svelte"
    import NewsTeaser from "./widgets/NewsTeaser.svelte"

    export let block: ContentBlock<"homepageTeaser">
</script>

<div class="teaser row">
    <div>
        <HomePageSlider slides="{block.homepageTeaser.slider}" />
    </div>
    <div>
        <IntroductionText
            brightBg="{true}"
            column="{{
                type: 'introductionText',
                introductionText: {
                    shortDescription: block.homepageTeaser.shortDescription,
                    description: block.homepageTeaser.description,
                },
            }}"
        />
        <NewsTeaser page="{block.homepageTeaser.newsPagePath}" />
    </div>
</div>

<style lang="less">
    @import "../../../css/variables.less";
    .teaser {
        padding-bottom: 24px;
        @media @max-tablet {
            flex-direction: column;
        }
        div {
            width: 0px;
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            gap: var(--default-gap);
            @media @max-tablet {
                width: 100%;
            }
        }
    }
</style>
